var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDualtoneTools48 = function SvgAIconDualtoneTools48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46154 15H36.5385C37.8979 15 39 16.2071 39 17.6961V26.0001C42.8218 26.0236 45.9127 29.129 45.9127 32.9564C45.9127 36.7982 42.7982 39.9127 38.9564 39.9127C37.0997 39.9127 35.4129 39.1853 34.1655 38H9.46154C8.10207 38 7 36.7929 7 35.3039V17.6961C7 16.2071 8.10207 15 9.46154 15Z",
    fill: "#DCECFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32H3.46154C2.10207 32 1 30.7929 1 29.3039V11.6961C1 10.2071 2.10207 9 3.46154 9H30.5385C31.8979 9 33 10.2071 33 11.6961V15",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15H19",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21H13",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6221 32V36",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21 36.9977L16.5 36.9977L12 36.9977",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9564 33.9127C36.7982 33.9127 39.9127 30.7982 39.9127 26.9564C39.9127 23.1145 36.7982 20 32.9564 20C29.1145 20 26 23.1145 26 26.9564C26 30.7982 29.1145 33.9127 32.9564 33.9127Z",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9994 36L37.875 31.8755",
    stroke: "#2C5A82",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconDualtoneTools48 as ReactComponent };
export default "data:image/svg+xml;base64,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";